'use client';

import { Route } from '@/utils/constants';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';

const LOCAL_STORAGE_KEY = 'signupviewed';
const TRUE_VALUE = 'true';

export function SignUpModal() {
	const [open, setOpen] = useState(false);
	const userSession = useSession();
	const router = useRouter();

	const handleOpen = useCallback(() => {
		const timer = setTimeout(() => {
			const alreadyShownPopup = localStorage.getItem(LOCAL_STORAGE_KEY) === TRUE_VALUE;

			// TODO Check route - if they are already upgrading/logging in then don't show this
			if (userSession.status !== 'authenticated' && !alreadyShownPopup) {
				localStorage.setItem(LOCAL_STORAGE_KEY, TRUE_VALUE);
				setOpen(true);
			}
		}, 45000);
		return () => clearTimeout(timer);
	}, [userSession.status]);

	useEffect(() => {
		handleOpen();
	}, [handleOpen]);

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Upgrade</DialogTitle>
				</DialogHeader>
				<div>
					You are currently on the free tier so only seeing performance data for younger and pre-retirement savers.
					Upgrade to get access to risk/return data, at-retirement performance, report building tools and a wide range
					of additional analysis and comparison tables.
				</div>
				<DialogFooter className='flex flex-row'>
					<DialogClose asChild>
						<Button type='button' variant='secondary'>
							Close
						</Button>
					</DialogClose>
					<Button
						type='button'
						onClick={() => {
							setOpen(false);
							router.push(Route.upgrade);
						}}
					>
						Upgrade
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
